<template>
  <div class="Form">
    <form ref="form">
      <slot></slot>
    </form>
  </div>
</template>
<script>
import { mapState } from 'vuex';

const isArray = (e) => Array.isArray(e);
const isObject = () => Object.prototype.toString.call() === '[object Object]';
// 金额规则判断
const amountRuleJudgment = ({ min, max, col }) => ({
  regExp: col <= max && col >= min,
});
export default {
  name: 'Form',
  data() {
    return {
      promiseAll: [],
    };
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  props: ['rules', 'model'],
  methods: {
    isArrayRegPromise(i) {
      this.rules[i].forEach((e) => {
        const promise = new Promise((resolve, reject) => {
          let value = this.model[i];
          if (isObject(this.model[i])) {
            value = this.model[i].value;
          }
          if (i === 'phone') {
            value = value.replace(/\s+/g, '');
          }

          if (i === 'loanAmount') {
            const { regExp } = amountRuleJudgment({
              min: this.publicPage.min,
              max: this.publicPage.max,
              col: this.model.loanAmount,
            });
            // eslint-disable-next-line no-unused-expressions
            regExp ? resolve() : reject();
          } else if (e.pattern !== '' && e.pattern) {
            const reg = new RegExp(e.pattern);
            // eslint-disable-next-line no-unused-expressions
            reg.test(value) ? resolve() : reject(i);
          } else if (e.required) {
            const reg = /\S/;
            // eslint-disable-next-line no-unused-expressions
            reg.test(value) ? resolve() : reject(i);
          }
        });
        this.promiseAll.push(promise);
      });
    },
    everyLast(i) {
      const pattern = /\S/;
      const promise = new Promise((resolve, reject) => {
        if (pattern.test(this.model[i])) {
          resolve();
        } else {
          reject();
        }
      });
      this.promiseAll.push(promise);
    },
  },
  watch: {
    model: {
      handler() {
        this.promiseAll = [];
        for (const i in this.model) {
          isArray(this.rules[i]) && this.isArrayRegPromise(i);
          if (this.model[i] === true || this.model[i] === false) {
            const promise = new Promise((resolve, reject) => {
              if (this.model[i]) {
                resolve();
              } else {
                reject();
              }
            });
            this.promiseAll.push(promise);
          }
        }
        Promise.all(this.promiseAll)
          .then(() => {
            this.$emit('input', true);
          })
          .catch((i) => {
            // console.log(i, '哪个正则没过');
            this.$emit('input', false);
          });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style scoped></style>
